import { baseUrl, QuizyUrl } from "../../libs/env";
import { AdminBottomButtonPannel } from "./AdminBottomButtonPannel";
import { GPT4BottomButtonPannel } from "./GPT4BottomButtonPannel";
import { StudentButtonPannel } from "./StudentButtonPannel";
import { SchoolTeacherBottomButtonpannel } from "./SchoolTeacherBottomButtonpannel";
import { AccountType } from "../../components/constants/constants";

export const BottomButtonPannel = ({
  isReview,
  data,
  IsonRecorder,
  isSubmitting,
  creatQuizDataThenSaveAndExit,
  creatQuizDataAndSave,
  getStudentid,
  currentPage,
  setCurrentPage,
  downloadPDF,
  setClearanswers,
  GradingToggle,
  IsFeedbackGenerating,
  GradeWithAI,
  ReportToggle
}) => {
  let params = new URL(document.location).searchParams;
  let book_id = params.get("book_id");
  let exercise_id = params.get("exercise_id");
  let exercise_page_number = params.get("e-p-n");
  let show_exercises = params.get("s-e");
  let search = params.get("search");
  let st_c_t_c = params.get("st_c_t_c");
  let st_le_c = params.get("st_le_c");
  let ex_b_c = params.get("ex_b_c");
  let st_th_c = params.get("st_th_c");
  let st_fn_c = params.get("st_fn_c");
  let st_gr_c = params.get("st_gr_c");
  let exercise_page_no = params.get("e-p-n");
  let student_level = params.get("level");
  let content_type = params.get("type");

  let get_tab = params.get("tab");
  let student_assignment_page_number = params.get(
    "student_assignment_page_number"
  );
  let show_assignment_list = params.get("show_assignment_list");
  let start_date = params.get("start_date");
  let end_date = params.get("end_date");
  let status = params.get("status");
  let exercise_prompt_content = params.get("exercise_prompt_content");
  let task_type = params.get("task_type");
  let student = params.get("student");
  let level = params.get("level");
  let deadline = params.get("deadline");
  let student_name = params.get("student_name");
  let homework_tab_query_string = `student_name=${student_name}&show_assignment_list=${show_assignment_list}&student_assignment_page_number=${student_assignment_page_number}&start_date=${start_date}&end_date=${end_date}&status=${status}&exercise_prompt_content=${exercise_prompt_content}&task_type=${task_type}&student=${student}&level=${level}&deadline=${deadline}`;
  let redirect = params.get("redirect");
  let book_section_id = params.get("section-id");
  let book_chapter_id = params.get("chapter-id");
  let edit_template = params.get("edit_template");

  return (
    <div className="px-0">
      {window.location.origin.includes(QuizyUrl) && data.user_type !== AccountType.STUDENT  ? (
        <GPT4BottomButtonPannel
          redirect={redirect}
          book_section_id={book_section_id}
          book_chapter_id={book_chapter_id}
          show_send_task_button={true}
          isReview={isReview}
          getStudentid={getStudentid}
          student_level={student_level}
          exercise_page_no={exercise_page_no}
          exercise_id={exercise_id}
          book_id={book_id}
          ex_b_c={ex_b_c}
          baseUrl={baseUrl}
          data={data}
          exercise_page_number={exercise_page_number}
          show_exercises={show_exercises}
          search={search}
          content_type={content_type}
          st_c_t_c={st_c_t_c}
          st_th_c={st_th_c}
          st_gr_c={st_gr_c}
          st_fn_c={st_fn_c}
          st_le_c={st_le_c}
          isSubmitting={isSubmitting}
          get_tab={get_tab}
          homework_tab_query_string={homework_tab_query_string}
          edit_template={edit_template}
          setClearanswers={setClearanswers}
          downloadPDF={downloadPDF}
          GradingToggle={GradingToggle}
          GradeWithAI={GradeWithAI}
          IsFeedbackGenerating={IsFeedbackGenerating}
          ReportToggle={ReportToggle}
        />
      ) : data.user_type === AccountType.STAFF ||
        data.user_type === AccountType.ANONYMOUSE_USER ||
        data.user_type === AccountType.STAFF_AND_SCHOOL_ACCOUNT ? (
        <AdminBottomButtonPannel
          redirect={redirect}
          book_section_id={book_section_id}
          book_chapter_id={book_chapter_id}
          show_send_task_button={true}
          isReview={isReview}
          getStudentid={getStudentid}
          student_level={student_level}
          exercise_page_no={exercise_page_no}
          exercise_id={exercise_id}
          book_id={book_id}
          ex_b_c={ex_b_c}
          baseUrl={baseUrl}
          data={data}
          exercise_page_number={exercise_page_number}
          show_exercises={show_exercises}
          search={search}
          content_type={content_type}
          st_c_t_c={st_c_t_c}
          st_th_c={st_th_c}
          st_gr_c={st_gr_c}
          st_fn_c={st_fn_c}
          st_le_c={st_le_c}
          isSubmitting={isSubmitting}
          get_tab={get_tab}
          homework_tab_query_string={homework_tab_query_string}
        />
      ) : data.user_type === AccountType.STUDENT ? (
        <StudentButtonPannel
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isReview={isReview}
          creatQuizDataThenSaveAndExit={creatQuizDataThenSaveAndExit}
          isSubmitting={isSubmitting}
          IsonRecorder={IsonRecorder}
          creatQuizDataAndSave={creatQuizDataAndSave}
          data={data}
        />
      ) : (
        <SchoolTeacherBottomButtonpannel
          redirect={redirect}
          book_section_id={book_section_id}
          book_chapter_id={book_chapter_id}
          isReview={isReview}
          getStudentid={getStudentid}
          student_level={student_level}
          exercise_page_no={exercise_page_no}
          exercise_id={exercise_id}
          book_id={book_id}
          ex_b_c={ex_b_c}
          baseUrl={baseUrl}
          data={data}
          exercise_page_number={exercise_page_number}
          show_exercises={show_exercises}
          search={search}
          st_c_t_c={st_c_t_c}
          content_type={content_type}
          st_th_c={st_th_c}
          st_gr_c={st_gr_c}
          st_fn_c={st_fn_c}
          st_le_c={st_le_c}
          isSubmitting={isSubmitting}
          get_tab={get_tab}
          homework_tab_query_string={homework_tab_query_string}
        />
      )}
    </div>
  );
};
